import { rem, zIndex } from "@s7/styles";
import { useEffect } from "react";
import { useIsChatOpen } from "./useIsChatOpen";
export var useUpdateStyles = function (isChatVisible) {
    var isOpen = useIsChatOpen();
    var isDesktop = window.matchMedia('(min-width: 1272px)').matches;
    var isMobile = window.matchMedia('(max-width: 451px)').matches;
    useEffect(function () {
        var _a, _b;
        (_b = (_a = window.chat) === null || _a === void 0 ? void 0 : _a.updateOptions) === null || _b === void 0 ? void 0 : _b.call(_a, {
            styles: {
                button: {
                    display: (isChatVisible || isOpen) && !isMobile ? 'flex' : 'none',
                    bottom: rem(isDesktop ? 0 : 63),
                },
                chat: {
                    bottom: rem(isDesktop ? 80 : 143),
                    height: isMobile ? '100%' : "calc(100% - ".concat(rem(!isDesktop ? 160 : 224), ")"),
                    zIndex: isMobile ? zIndex('popover') + 11 : zIndex('navigation') - 1,
                }
            }
        });
    }, [isChatVisible, isOpen, isDesktop, isMobile]);
};
